import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { CATEGORIES } from "@/lib/data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-coal">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <Logo size={34} />
            <p className="mt-6 max-w-sm text-mist leading-relaxed text-sm">
              A mystic&rsquo;s apothecary and reading room. Crystals with memories,
              cards with opinions, and everything made slowly by hand.
            </p>
            <p className="mt-5 text-sm text-mist/80">
              Write to the keeper:{" "}
              <a
                href="mailto:moonspiritvida@gmail.com"
                data-testid="footer-contact-email"
                className="text-gold border-b border-gold/40 pb-0.5 transition-colors duration-300 hover:text-paper"
              >
                moonspiritvida@gmail.com
              </a>
            </p>
            <Link
              to="/tarot"
              data-testid="footer-reading-cta"
              className="mt-8 inline-flex items-center rounded-full border border-gold/50 px-6 py-2.5 text-[13px] uppercase tracking-widest2 text-gold transition-colors duration-300 hover:bg-gold hover:text-ink"
            >
              Book a tarot reading
            </Link>
          </div>

          <div className="md:col-span-3">
            <p className="text-[12px] uppercase tracking-widest2 text-sage/80">The Shop</p>
            <ul className="mt-5 space-y-3">
              {CATEGORIES.slice(0, 5).map((c) => (
                <li key={c.key}>
                  <Link
                    to={`/shop?category=${c.key}`}
                    data-testid={`footer-link-${c.key}`}
                    className="text-sm text-mist transition-colors duration-300 hover:text-gold"
                  >
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-[12px] uppercase tracking-widest2 text-sage/80">The Room</p>
            <ul className="mt-5 space-y-3">
              <li>
                <Link to="/tarot" data-testid="footer-link-readings" className="text-sm text-mist transition-colors duration-300 hover:text-gold">
                  Tarot readings
                </Link>
              </li>
              <li>
                <Link to="/shop" data-testid="footer-link-all" className="text-sm text-mist transition-colors duration-300 hover:text-gold">
                  Everything
                </Link>
              </li>
              <li>
                <Link to="/admin" data-testid="footer-link-admin" className="text-sm text-mist/50 transition-colors duration-300 hover:text-gold">
                  Keeper&rsquo;s desk
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-line flex flex-col sm:flex-row justify-between gap-4">
          <p className="text-xs text-mist/50">&copy; {new Date().getFullYear()} moonspiritvida. All rights reserved.</p>
          <p className="text-xs text-mist/50 italic font-display text-base">read by candlelight</p>
        </div>
      </div>
    </footer>
  );
}
